import React from "react";

/** Announcement / special photos: fixed 4:3 ratio, lazy-loaded, swipeable row on phones. */
export const AnnouncementImages: React.FC<{ images?: (string | null | undefined)[]; alt?: string; className?: string }> = ({ images, alt = "", className = "" }) => {
  const list = Array.from(new Set((images || []).filter((u): u is string => typeof u === "string" && /^https?:\/\//.test(u)))).slice(0, 6);
  if (!list.length) return null;
  return (
    <div className={`flex gap-2 overflow-x-auto snap-x snap-mandatory ${className}`}>
      {list.map((src, i) => (
        <a key={src} href={src} target="_blank" rel="noopener noreferrer"
          className={`snap-start shrink-0 ${list.length === 1 ? "w-full" : "w-[80%] sm:w-[48%]"} aspect-[4/3] rounded-xl overflow-hidden bg-gray-100`}>
          <img src={src} alt={alt ? `${alt} (${i + 1})` : ""} loading="lazy" decoding="async" className="w-full h-full object-cover" />
        </a>
      ))}
    </div>
  );
};
export default AnnouncementImages;
